module.exports = __webpack_public_path__ + "static/media/loginBackground.8a1d1b2d.jpg";